import * as React from "react";
import { forwardRef } from "react";
const SvgGreenTickIconOutline = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.825 6.31689L8.33333 11.8086L6.175 9.65856L5 10.8336L8.33333 14.1669L15 7.50023L13.825 6.31689Z", fill: "#7DDFBB" }));
const ForwardRef = forwardRef(SvgGreenTickIconOutline);
export { ForwardRef as ReactComponent };
